import React from "react";

const TempRazorpayButton = () => {
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // async function callEdgeFunctionForOrderId() {
  //   const { data, error } = await supabase.functions.invoke(
  //     "create_razorpay_order",
  //     {
  //       body: {
  //         amount: 1000000,
  //         currency: "INR",
  //         receipt: "Receipt no. 1",
  //         notes: {
  //           notes_key_1: "Tea, Earl Grey, Hot",
  //           notes_key_2: "Tea, Earl Grey… decaf.",
  //         },
  //       },
  //     }
  //   );

  //   if (error) {
  //     console.error("Edge Function Error:", error);
  //   } else {
  //     console.log("Edge Function Response:", data);
  //     const orderID = data.id; // Assuming the response contains the order ID
  //     handlePayment(orderID);
  //   }
  // }

  const createOrderApiCall = async () => {
    const baseUrl = "http://0.0.0.0:8000";
    const endPoint = "/create-order";
    const requestBody = {
      amount: 1000000,
      currency: "INR",
    };

    const requestHeaders = {
      "Content-Type": "application/json"
    };

    const res = await fetch(`${baseUrl}${endPoint}`, {
      method: "POST",
      headers: requestHeaders,
      body: JSON.stringify(requestBody),
    });

    const data = await res.json();
    console.log("Created order:", data);

    if (res.ok) {
      const orderID = data.order_id; // Assuming the response contains the order ID
      handlePayment(orderID);
    } else {
      console.error("Error creating order:", data);
    }
  }

  // const createOrder = async () => {
  //   const res = await fetch(
  //     "https://zuepyymuebmlbwynssnk.supabase.co/functions/v1/create_razorpay_order",
  //     {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({
  //         amount: 1000000,
  //         currency: "INR",
  //         receipt: "Receipt no. 1",
  //         notes: {
  //           notes_key_1: "Tea, Earl Grey, Hot",
  //           notes_key_2: "Tea, Earl Grey… decaf.",
  //         },
  //       }),
  //     }
  //   );

  //   const data = await res.json();
  //   console.log("Created order:", data);
  // };

  const handlePayment = async (orderID) => {
    const res = await loadRazorpayScript();

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const options = {
      key: process.env.REACT_APP_RAZORPAY_TEST_API_KEY, // Replace with your actual key
      amount: "1000000",
      currency: "INR",
      name: "Fusshn",
      description: "Ticket Booking",
      image:
        "https://firebasestorage.googleapis.com/v0/b/fusshn-aef8e.appspot.com/o/app_logo%2Fapp_icon.png?alt=media&token=a5953a7e-65fb-4d5e-baa5-1cb5f1723556",
      order_id: orderID, // Replace with real order_id from backend
      handler: function (response) {
        alert("Payment ID: " + response.razorpay_payment_id);
        // Optionally, send these to your server for verification
      },
      prefill: {
        name: "Kalash",
        email: "kalash@fusshn.in",
        contact: "9000090000",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#11111",
      },
    };

    const rzp = new window.Razorpay(options);

    rzp.on("payment.failed", function (response) {
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });

    rzp.open();
  };

  return (
    <>
      <h1 className="text-2xl font-bold mb-4">Razorpay Payment</h1>
      <button onClick={createOrderApiCall} className="nav-btn">
        Pay
      </button>
    </>
  );
};

export default TempRazorpayButton;


// 1. Create Order for transaction,
// 2. Extract Order ID from the response,
// 3. 